import React, { useState, useRef } from 'react'
import { Model } from 'survey-core'
import { Survey } from 'survey-react-ui'
// import 'survey-core/defaultV2.min.css'

import { useConvertSurvey } from '../hooks/useConvertSurvey'
import { useSubmitAnswers } from '../hooks/useSubmitAnswers'
import 'survey-core/i18n/traditional-chinese'

const Agree = ({
  setAc,
  setTk,
  ac,
  tk,
  pid,
  setIsLoading,
  setCompletionMessage,
}) => {
  const [myAgreeJson, setMyAgreeJson] = useState(null)
  // 需要登入嗎
  const requiresLogin = {
    login: false,
    title: '驗證碼',
    placeholder: '請輸入驗證碼',
    alert: '請填寫您的手機或信箱',
  }
  const [imagesReadingTime, setImagesReadingTime] = useState(0)
  // 圖片閱讀時間(秒)
  // useEffect(() => {
  //   setImagesReadingTime(3)
  // }, [])
  const completedHtml = `<h3>問卷正在提交中，請稍候。</h3><h3>請在成功頁面顯示後再離開。</h3><h4>如有填卷相關問題請洽：</h4> <a href='https://lin.ee/HWETcqy'>https://lin.ee/HWETcqy</a><h4 style='margin-top:50px'>填寫其他問卷：</h4> <a href=${window.location.origin}>${window.location.origin}</a>`

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const agreeSurvey = new Model(myAgreeJson)

  // 問卷編號
  // const pid = pid
  // 跳題 小心複選題要用陣列

  // const visibleIfConditionsInit = {
  //   q6: '{q5} = 0 or {q5} = 1 or {q5} = 2 or {q5} = 3',
  //   q7: '{q6} = ["none"]',
  //   q36: `{q35} <> ['none']`,
  // }
  const cannotOpenQuestionSetN = `{q34} anyof [0, 1, 2, 3, 4, 5, 6, 7 ,8, 9, 10, 11, 12, 'other']`

  const visibleIfConditionsInit = {
    q4: '{q3} = 0',
    q7: '{q6} = 0',
    q8: '{q6} = 1 or {q7} = 1',
    q10: '{q9} = 0',
    q11: '{q9} = 1 or {q10} = 1',
    q15: '{q14} = 0',
    q16: '{q14} = 0 or {q14} = 1',
    q17: '{q14} = 0 or {q14} = 2',
    q18: '{q14} = 0 or {q14} = 1',
    q19: '{q14} = 0 or {q14} = 2',
    q24: '{q23} anyof [1, 2, 3, 4, 5, 6, 7 ,8, 9, 10, 11]',
    q25: '{q23} anyof [1, 2, 3, 4, 5, 6, 7 ,8, 9, 10, 11]',
    q28: '{q27} = 0 or {q27} = 1 or {q27} = 2 or {q27} = 3 or {q27} = 4 or {q27} = 5 or {q27} = 6',
    q46: '{q45} = 1',
    q47: '{q45} = 1',
    q48: '{q45} = 1',
    q49: '{q45} = 1',
    q52: '{q51} = 1 or {q51} = 2 or {q51} = 3 or {q51} = 4 or {q51} = 5',
    q58: '{q57} = 1',
    q59: '{q57} = 2',
    q61: '{q60} = 1',
    q62: '{q60} = 2',
    q64: '{q63} = 1',
    q65: '{q63} = 2',
    q67: '{q66} = 1',
    q68: '{q66} = 2',
    q70: '{q69} = 1',
    q71: '{q69} = 2',
    q73: '{q72} = 1',
    q74: '{q72} = 2',
    q76: '{q75} = 1',
    q77: '{q75} = 2',
    q79: '{q78} = 1',
    q80: '{q78} = 2',
    q82: '{q81} = 1',
    q83: '{q81} = 2',
    q85: '{q84} = 1',
    q86: '{q84} = 2',
  }

  /**
   * {
    "q46": "{q45} = 1",
    "q47": "{q45} = 1",
    "q48": "{q45} = 1",
    "q49": "{q45} = 1",
    "q52": "{q51} = 1 or {q51} = 2 or {q51} = 3 or {q51} = 4 or {q51} = 5",
    "q58": "{q57} = 1",
    "q59": "{q57} = 1",
    "q61": "{q60} = 1",
    "q62": "{q60} = 1",
    "q64": "{q63} = 1",
    "q65": "{q63} = 1",
    "q67": "{q66} = 1",
    "q68": "{q66} = 1",
    "q70": "{q69} = 1",
    "q71": "{q69} = 1",
    "q73": "{q72} = 1",
    "q74": "{q72} = 1",
    "q76": "{q75} = 1",
    "q77": "{q75} = 1",
    "q79": "{q78} = 1",
    "q80": "{q78} = 1",
    "q82": "{q81} = 1",
    "q83": "{q81} = 1",
    "q85": "{q84} = 1",
    "q86": "{q84} = 1"
}
   */
  // const visibleIfConditionsInit = null
  // const pageVisibleIfConditionsInit = null

  // 非必填(從 0 計算)
  // const notRequired = [100]
  const notRequired = null

  const mappedRateChoice = null
  // const pageBreakQuestions = ['q6', 'q11', 'q15']
  const pageBreakQuestions = null

  // const triggersConditionsInit = [
  //   {
  //     type: 'complete',
  //     expression:
  //       '({q0} = 1) or ({q1} = 0 or {q1} = 1 or {q1} = 2 or {q1} = 3 or {q1} = 4 or {q1} = 5 or {q1} = 8 or {q1} = 9) or ({q2} = 1) or ({q5} = 0 or {q5} = 1 or {q5} = 2 or {q5} = 3)',
  //     //     expression: `{q3} <> 4 or ({q4} = 16 or {q4} = 20 or {q4} = 21)`,
  //   },
  //   {
  //     type: 'complete',
  //     expression: '{q6} notcontains 0',
  //   },
  // ]
  const triggersConditionsInit = null
  // const pageVisibleIfConditionsInit = null

  const convertedSurvey = useConvertSurvey({
    survey: agreeSurvey,
    pid,
    setAc,
    setTk,
    ac,
    tk,
    setMyAgreeJson,
    imagesReadingTime,
    setImagesReadingTime,
    setIsLoading,
    completedHtml,
    visibleIfConditionsInit,
    notRequired,
    mappedRateChoice,
    pageBreakQuestions,
    requiresLogin,
    triggersConditionsInit,
  })

  const newSurvey = new Model(convertedSurvey)
  // useEffect(() => {
  //   console.log('convertedSurvey', convertedSurvey)
  // }, [convertedSurvey])
  const endMessage = `<h4 style='text-align: center'>問卷已成功送出</h4><h4 style='text-align: center'>請先停留在這個畫面</h4><h4 style='text-align: center'>等訪員確認後 給你小禮物後</h4><h4 style='text-align: center'>再按「完成」前往下載 EZChoice 或填寫更多問卷</h4>`

  // 帶入選項
  // const questionMappings = {
  //   q29: 'q31',
  // }

  function helpFunction(survey, options) {
    // 參考 P231113152849 或 P231101165555 或 P231206105643(政大帶入選項)
  }

  const endSurveyMsg = (survey) => {
    setCompletionMessage(endMessage)
  }

  const canShowPrevButtonPages = null
  const choicesOrderRef = useRef({})
  const choiceIndexMapRef = useRef({})

  useSubmitAnswers({
    survey: newSurvey,
    pid,
    ac,
    tk,
    imagesReadingTime,
    setIsLoading,
    helpFunction,
    canShowPrevButtonPages,
    choicesOrderRef,
    choiceIndexMapRef,
    endSurveyMsg,
  })

  return (
    <>
      {convertedSurvey ? (
        <Survey model={newSurvey} />
      ) : myAgreeJson ? (
        <Survey model={agreeSurvey} />
      ) : (
        <></>
      )}
    </>
  )
}

export default Agree
